// extracted by mini-css-extract-plugin
export default {"sidebar":"B_bX","sidebarHeader":"B_bY","fileinput":"B_bZ","form":"B_b0","sponsoredText":"B_cs"};